const entry = {
  secure: 'Enterprise workspace identified',
  title: 'Start from enterprise truth, not another form.',
  body: 'Navigator found the enterprise projects owned by this invitation. Continue the last project or begin a diagnosis for a new market objective.',
  identity: 'Current invitation identity',
  changeEmail: 'Use another email',
  signingOut: 'Signing out…',
  signOutFailed: 'Could not sign out. Check your connection and try again.',
  existingTitle: 'Return to your project',
  existingBody: 'Your last project is selected by default',
  projectCount: '{count} projects',
  ready: 'Ready',
  continueSetup: 'Continue setup',
  targetMarkets: 'Target markets',
  lastOpened: 'Last opened',
  noMarkets: 'Not set',
  viewProjects: 'View existing projects',
  startDiagnosis: 'Start a new diagnosis',
  serverTruth: 'Projects come from the server. This device remembers only your last selection.',
  emptyTitle: 'Create your first project',
  emptyHint: 'No enterprise project belongs to this invitation yet',
  emptyLead: 'Complete enterprise setup in four steps',
  emptyBody: 'Add enterprise and product details, choose markets, attach public links and project materials, then confirm the diagnosis scope.',
  emptyNote: 'You can save and leave before confirming materials.',
}

export default entry
